<div class="unauthorized-container">
  <div class="unauthorized-card">
    <div class="unauthorized-icon">
      <i class="fas fa-lock"></i>
    </div>
    <h1 class="unauthorized-title">Accesso non autorizzato</h1>
    <p class="unauthorized-message">
      Non sei autorizzato a visualizzare questo applicativo.<br />
      Contattare l'amministratore per richiedere l'accesso.
    </p>
    <button class="unauthorized-btn" (click)="signOut()">
      <i class="fas fa-sign-out-alt"></i> Esci
    </button>
  </div>
</div>
